import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable no-use-before-define */
import React from "react";
import styles from "./styles.module.css";
function Banner(props) {
    return (_jsx(_Fragment, { children: _jsxs("div", { className: `${styles.teal} ${props.theme === "light" ? styles.light : ""}`, children: ["Free US Shipping over $60", _jsx("span", { className: styles.pipe, children: " | " }), _jsx("br", { className: styles.break }), "Change or Cancel Anytime"] }) }));
}
export default Banner;
